import {
  EXTEND_JOB_EXPIRE_DATE_REQUEST,
  EXTEND_JOB_EXPIRE_DATE_SUCCESS,
  EXTEND_JOB_EXPIRE_DATE_FAILURE,
  EXTEND_JOB_EXPIRE_DATE_RESET,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
};

const extendJobExpireDateReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXTEND_JOB_EXPIRE_DATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case EXTEND_JOB_EXPIRE_DATE_SUCCESS:
      console.log("us", action.payload);
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case EXTEND_JOB_EXPIRE_DATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case EXTEND_JOB_EXPIRE_DATE_RESET:
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default extendJobExpireDateReducer;
